import HttpClient from "../../boot/HttpClient";
import { criarCookie, cookieEstaValido, removerCookie } from "../../boot/CookiesHandler";
import router from "@/router";
// import moment from "moment/moment";

const nomeCookie = 'provedores-token';

const logarUsuario = async ({ commit }, payload) => {
    commit('LOGANDO', true);

    const resp = await HttpClient.post('/autenticacao/entrar', payload)
        .then(response => {
            const dados = response.data.data;
            const usuario = dados.user;
            const token = dados.token;

            commit('SALVAR_USUARIO_STATE', { ...usuario, token });

            criarCookie({
                nome: nomeCookie,
                valor: token,
            });

            localStorage.setItem('provedores-usuario', JSON.stringify({
                ...usuario,
                token,
            }));

            if (usuario.ctrl_provedores && usuario.ctrl_provedores.length > 0) {
                const provedorAtivo = usuario.ctrl_provedores[0].id;
                localStorage.setItem('provedorAtivo', provedorAtivo);
            }

            return response;
        })
        .catch(error => {
            return error.response;
        })
        .finally(() => {
            commit('LOGANDO', false);
        });

    return resp;
};

const verificarToken = async () => {
    try {
        await HttpClient.get('/autenticacao/verificar-token');
        return true;
    } catch (error) {
        return false;
    }
}

const usuarioEstaLogado = async ({ commit, dispatch }) => {
    if (!cookieEstaValido(nomeCookie)) {
        await dispatch('deslogarUsuario');
        return false;
    }

    const tokenValido = await verificarToken();
    if (!tokenValido) {
        await dispatch('deslogarUsuario');
        return false;
    }

    const usuario = JSON.parse(localStorage.getItem("provedores-usuario"));
    commit('SALVAR_USUARIO_STATE', usuario);

    return true;
}


const deslogarUsuario = async ({ commit, dispatch }, payload) => {
    const resp = await HttpClient.post('autenticacao/sair', payload).then(response => {
        localStorage.removeItem('provedores-usuario')
        removerCookie(nomeCookie)
        commit('DELETAR_USUARIO_STATE');
        
        dispatch('ctrlModulos/limparModuloAtivo', null, { root: true });
        
        router.push('/login');
        return response
    }).finally(() => {
        commit('LOGANDO', false);
    });

    return resp
}

const recarregarMenus = async ({ commit, state }) => {
    try {
        const response = await HttpClient.get('/usuarios/me');
        
        const userData = response.data.data;
        
        const usuarioAtualizado = {
            ...state.login,
            ...userData,
        };
        
        commit('SALVAR_USUARIO_STATE', usuarioAtualizado);
        
        localStorage.setItem('provedores-usuario', JSON.stringify(usuarioAtualizado));
        
        return response;
    } catch (error) {
        console.error('Erro ao recarregar menus:', error);
        return error.response;
    }
}

export {
    logarUsuario,
    usuarioEstaLogado,
    deslogarUsuario,
    recarregarMenus
}